var path = 'app/admin/adminTabsSection.html';
var html = "<form name=\"sectionForm\" class=\"admin-section\" novalidate autocomplete=\"off\">\n  <ui-view></ui-view>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;